import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(public toastController: ToastController,private router: Router) { }

  async presentToast(message:any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }

  async presentToastWithOptions() {
    const toast = await this.toastController.create({
      header: 'Toast header',
      message: 'Click to Close',
      position: 'top',
      buttons: [
        {
          side: 'start',
          icon: 'star',
          text: 'Favorite',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

  showToast() {
    this.toastController.create({
      // header: 'Hurrayy!',
      message: 'Added to Cart!',
      position: 'bottom',
      duration: 2000,
      cssClass: 'my-custom-class',
      buttons: [
        {
          side: 'end',
          icon: 'cart',
          text: 'View Cart',
          handler: () => {
            this.router.navigate(['/cart'])
            console.log('Cart Button Clicked');
          }
        }
        // , {
        //   side: 'end',
        //   text: 'Close',
        //   role: 'cancel',
        //   handler: () => {
        //     console.log('Close clicked');
        //   }
        // }
      ]
    }).then((obj) => {
      obj.present();
    });
  }
}
